export const buildPurpose = process.env.VUE_APP_BUILD_PURPOSE;

export const fallbackLocale = 'en-US';

const apiUrlMap = {
  test: 'https://testapi.payarc.net/v1',
  stage: 'https://staging.payarc.net:9000/v1',
  release: 'https://api.payarc.net/v1',
  preprod: 'https://api.payarc.io/v1',
  preprod2: 'https://api2.payarc.io/v1',
  dev: 'http://localapi2.payarc.net/v1',
  // bluegreen: 'https://api.payarc.net:8443/v1',
  bluegreen: 'https://api2.payarc.net/v1',
};
export const apiUrl = apiUrlMap[buildPurpose] || apiUrlMap.dev;

const formLoadingPageUrlMap = {
  test: 'https://test.payarc.net:9091?loading=true',
  stage: 'https://staging.payarc.net:9091?loading=true',
  release: 'https://release.payarc.net:9091?loading=true',
  preprod: 'https://release.payarc.io:9091?loading=true',
  preprod2: 'https://release2.payarc.io:9091?loading=true',
  dev: 'https://dev.payarc.io:9091?loading=true',
  bluegreen: 'https://release.payarc.net:9091?loading=true',
};
export const formLoadingPageUrl = formLoadingPageUrlMap[buildPurpose] || formLoadingPageUrlMap.dev;

export const paypalClientId = (process.env.VUE_APP_BUILD_PURPOSE === 'release' || process.env.VUE_APP_BUILD_PURPOSE === 'bluegreen') ? 'AQOiuJxBnckcmQgf-3KgQIdsv9tIUINwb5YBVL2fKhKXk5TUQMB-sDiE0FwyCEkUPGZKhkowU-BkoJsM'
  : 'AYCHGtqmA9fg4Y2nZMha_U5A-qc3ll7kAemZmOWr-Eh2P7x_K_UZ3eWw0oJn4aLlzI3NZ99-WjPJAqSP';
